export const isFeatureEnabled = (flagName) => {
  if (typeof window !== 'undefined') {
    const flagValue = window.localStorage.getItem(flagName);

    // Make Bookalet the default unless explicitly disabled
    if (flagName === 'useBookalet') {
      return flagValue !== 'false'; // Default to true
    }

    // Other flags are opt-in (default to false)
    return flagValue === 'true';
  }

  // Default behavior for non-browser environments
  if (flagName === 'useBookalet') {
    return true; // Default to on for SSR etc.
  }
  return false;
};
